import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/invoiceService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class InvoiceEditForm extends Form {
  state = {
    imageUrl: false,
    invoiceDate: new Date(),
    data: {
      invoice_number: "",
      client: "",
      total_work_done: "",
      retention_percentage: "",
      retention_amount: "",
      total_amount: "",
      vat_percentage: "",
      vat_amount: "",
      grand_total: "",
      reduction: "",
    },
    errors: {},
  };

  schema = {
    invoice_number: Joi.string().required().label("Invoice #"),
    client: Joi.string().required().label("Client"),
    total_work_done: Joi.number().required().label("Total Work Done"),
    retention_percentage: Joi.number().required().label("Retention Percentage"),

    // retention_amount: Joi.number()
    // .required()
    // .label("Retention Amount"),
    // total_amount: Joi.number()
    // .required()
    // .label("Retention Amount"),
    vat_percentage: Joi.number().required().label("VAT Percentage"),

    reduction: Joi.number().label("Deduction"),
    // vat_amount: Joi.number()
    // .required()
    // .label("VAT Amount"),
    // grand_total: Joi.number()
    // .required()
    // .label("Grand Total")
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });

      const dateData = this.mapingData(account);

      console.log(dateData);

      this.setState({
        invoiceDate: new Date(dateData.invoiceDate),
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  mapingData(account) {
    return {
      invoiceDate: account.invoice_date,
    };
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  mapToViewModel(account) {
    return {
      invoice_number: account.invoice_number,
      client: account.client,
      total_work_done: account.total_work_done,
      retention_percentage: account.retention_percentage,
      //retention_amount:account.retention_amount,
      // total_amount:account.total_amount,
      vat_percentage: account.vat_percentage,
      reduction: account.reduction,
      //vat_amount:account.vat_amount,
      // grand_total:account.grand_total,
    };
  }

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  handleChangeInvoice = (date) => {
    this.setState({
      invoiceDate: date,
    });
  };

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      let formData = new FormData();
      formData.append("invoice_number", this.state.data.invoice_number);
      formData.append("client", this.state.data.client);
      formData.append("total_work_done", this.state.data.total_work_done);
      formData.append(
        "retention_percentage",
        this.state.data.retention_percentage
      );
      formData.append("retention_amount", this.state.data.retention_amount);
      formData.append("total_amount", this.state.data.total_amount);
      formData.append("vat_percentage", this.state.data.vat_percentage);
      formData.append("vat_amount", this.state.data.vat_amount);
      formData.append("grand_total", this.state.data.grand_total);
      formData.append("reduction", this.state.data.reduction);
      formData.append("attachment", this.state.imageUrl);

      formData.append("_method", "PUT");
      this.setState({ blocking: true });

      let event = new Date(this.state.invoiceDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);

      formData.append("invoice_date", date);

      await updateSingle(formData, ledgerTypeId);

      this.setState({ blocking: false });
      toast.success("Invoice has been updated successfully.");
      this.props.history.push("/invoices");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.passport_number)
          errors.passport_number = ex.response.data.errors.passport_number;

        if (ex.response.data.errors.identification_id)
          errors.identification_id = ex.response.data.errors.identification_id;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    // if (auth.getCurrentUser().email != "client-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update invoice</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/invoices")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update invoice</h3>
              <p>Provide the information below to update the invoice.</p>
              <label>Date</label>

              <DatePicker
                selected={this.state.invoiceDate}
                onChange={this.handleChangeInvoice}
                className="input"
              />
              {this.renderInput("invoice_number", "Invoice Number", "text")}
              {this.renderInput("client", "Client", "text")}
              {this.renderInput("total_work_done", "Total Work Done", "text")}
              {this.renderInput("retention_percentage", "Retention %", "text")}
              {this.renderInput("reduction", "Deduction", "text")}
              {this.renderInput("vat_percentage", "Vat %", "text")}
              <label>Attachment</label>
              <input
                className="input"
                type="file"
                onChange={this.onChangeFile}
              />

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default InvoiceEditForm;
